class EmployerApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getEmployees() {
        return this.fetchService.get('/employers/employees');
    }
}
export default EmployerApi;
